import { Box } from 'approot/shared/design-system/box/box.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { ImageThumbnailStatic } from 'approot/shared/images/images';
import ComponentAltTextLabel from '../component-alt-text/component-alt-text-label';
import * as Styled from './component-image-field.style';

export type ImageProps = {
  key: string;
  fileName: string;
  flip?: string | null;
  original?: string | null;
  alt?: string | null;
} | null;

export type Props = {
  image?: ImageProps;
  ariaLabel?: string;
  contentsOnly?: boolean;
  onEdit: () => void;
};

const ComponentImageField = ({
  image,
  ariaLabel,
  contentsOnly,
  onEdit,
}: Props) => (
  <Styled.ComponentImageField $contentsOnly={contentsOnly}>
    <Box $alignItems="center">
      <Box $marginRight={12}>
        <ImageThumbnailStatic
          imageUrl={image?.original || ''}
          width={48}
          data-selector="image-thumbnail-static"
        />
      </Box>
      <ComponentAltTextLabel hasAltText={!!image?.alt} />
    </Box>
    <SecondaryButton
      type="button"
      $isSmall
      aria-label={ariaLabel}
      onClick={onEdit}
      data-selector="btn-edit"
    >
      Edit
    </SecondaryButton>
  </Styled.ComponentImageField>
);

export default ComponentImageField;
